/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_AerobicInputs */

const en_ui_zone_aerobic = /** @type {(inputs: Ui_Zone_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aerobic`)
};

const de_ui_zone_aerobic = /** @type {(inputs: Ui_Zone_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aerob`)
};

/**
* | output |
* | --- |
* | "Aerobic" |
*
* @param {Ui_Zone_AerobicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_aerobic = /** @type {((inputs?: Ui_Zone_AerobicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_AerobicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_aerobic(inputs)
	return de_ui_zone_aerobic(inputs)
});